import classNames from "classnames";
import { DComponent } from "../DComponent";
import { MENU_MOBILE_NORMAL, MENU_MOBILE_USER } from "../../utils/menu";
import MenuSubCollapse from "../MenuSubCollapse";
import { Menu } from "../../models/Menu";
import { MINI_APP } from "../../utils/miniApp";
import { ROOT_GLOBAL } from "../../global/root";
import { LocalStorage } from "../../models/LocalStorage";

export default class MenuNavigation extends DComponent {
  constructor({
    parent,
    id,
    defaultLoading,
    menu = [],
    isMiniApp,
    hideNavigation,
    isAutoOpen,
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("MenuNavigation", {
        "hide-navigation": hideNavigation,
      }),
    }, true, defaultLoading);
    this.menu = menu;
    /** @type {MenuSubCollapse} */
    this.menuCollapse = undefined;
    this.isMiniApp = isMiniApp;
    this.isAutoOpen = isAutoOpen;
    this.hideNavigation = hideNavigation;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "MenuNavigation");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    if (this.isAutoOpen) {
      this.addMenuCollapse();
      $(".button-item.account", this.element).addClass("active");
    }

    $(".button-item.account", this.element).on("click", (e) => {
      this.addMenuCollapse();
      if (this.menuCollapse.isShow()) {
        $(".button-item.account", this.element).removeClass("active");
        this.menuCollapse.hide(true);
      } else {
        this.menuCollapse.show();
      }
    });

    $(".button-item.cart", this.element).on("click", (e) => {
      if (this.isMiniApp && !LocalStorage.isOldApp()) {
        MINI_APP.checkout();
      } else {
        let shopping = $("body").attr("dce_cart") || "";
        window.location.href = ROOT_GLOBAL.CHECKOUT + "/" + shopping;
      }
    });

    $(".button-item.stores", this.element).on("click", (e) => {
      if (this.isMiniApp && !LocalStorage.isOldApp()) {
        MINI_APP.openAvailableStore();
      } else {
        window.location.href = ROOT_GLOBAL.AVAILABLE_STORES;
      }
    });

    this.setUpActive();
  }

  addMenuCollapse() {
    if (this.menuCollapse) return;
    let menuItems = [...Menu.fromApiArray(MENU_MOBILE_USER), ...Menu.fromApiArray(MENU_MOBILE_NORMAL)];

    this.menuCollapse = new MenuSubCollapse({
      parent: $(".background-menu", this.element),
      menuItems: menuItems,
      isAutoOpen: this.isAutoOpen,
      onHide: () => {
        $("html, body").css("overflow", "auto");
        $(".button-item.account", this.element).removeClass("active");
      },
      onShow: () => {
        $("html, body").css("overflow", "hidden");
        $(".button-item", this.element).removeClass("active");
        $(".button-item.account", this.element).addClass("active");
      },
      onClose: () => {
        this.menuCollapse.hide(true);
        $(".button-item.account", this.element).removeClass("active");
        this.setUpActive();
      },
    })
    this.menuCollapse.on();
  }

  setUpActive() {
    let root = window.location.pathname;
    if (root === ROOT_GLOBAL.HOME_PAGE) {
      $(".button-item.home", this.element).addClass("active");
    }
    if (root.includes(ROOT_GLOBAL.AVAILABLE_STORES)) {
      $(".button-item.stores", this.element).addClass("active");
    }
    if (root.includes(ROOT_GLOBAL.CHECKOUT) || root.includes(ROOT_GLOBAL.PAYMENT)) {
      $(".button-item.cart", this.element).addClass("active");
    }
  }

  showNavigation(isShow) {
    if (LocalStorage.isMiniApp()) {
      MINI_APP.setShowNavigationBar(isShow);
      return;
    }
    isShow ? this.element.removeClass("hide-navigation") : this.element.addClass("hide-navigation")
  }

  off() {
    this.element.addClass("hide");
  }

  on() {
    this.element.removeClass("hide").removeClass("hide-navigation");
  }
}